import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withModifiers as _withModifiers, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "_flexcol" }
const _hoisted_2 = { class: "_mb-2" }
const _hoisted_3 = {
  class: "_flex _gap-2",
  "data-qa": `backer-center-payments-tabs`
}

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_base_tab = _resolveComponent("base-tab")

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _renderSlot(_ctx.$slots, "header")
    ]),
    _createElementVNode("nav", _hoisted_3, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.tabTypes, (tabType) => {
        return (_openBlock(), _createBlock(_component_base_tab, {
          key: tabType.key,
          variant: "link",
          "is-active": tabType.isActive,
          onClick: _withModifiers($event => ($options.onTabClick(tabType.key)), ["prevent"]),
          "data-qa": `backer-center-payments-tab:${tabType.name}`
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(tabType.displayName), 1 /* TEXT */)
          ]),
          _: 2 /* DYNAMIC */
        }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["is-active", "onClick", "data-qa"]))
      }), 128 /* KEYED_FRAGMENT */))
    ]),
    _renderSlot(_ctx.$slots, "default")
  ]))
}